import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container pageheader" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["hidden"]
const _hoisted_4 = { class: "info-card" }
const _hoisted_5 = {
  key: 0,
  class: "info-grid"
}
const _hoisted_6 = { class: "info-column" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1)
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1)
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Role:", -1)
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Blocked:", -1)
const _hoisted_15 = { class: "info-column" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Store Name:", -1)
const _hoisted_18 = { class: "tooltiptext tooltip-top" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-copy" }, null, -1)
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Date Created:", -1)
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Last Login:", -1)
const _hoisted_24 = {
  key: 1,
  class: "info-grid"
}

import { ref, computed } from 'vue';
import { useAuth0 } from "@auth0/auth0-vue";
import { useToast } from 'primevue/usetoast';
import ErrorModal from './ErrorModal.vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth0User',
  setup(__props) {

const toast = useToast();
const auth0 = useAuth0();
const emailSearch = ref('');
const userData = ref({
    blocked: false,
    email: '',
    name: '',
    user_metadata: {
        role: '',
        storeid: ''
    },
    last_login: '',
    created_at: '',
    storename: ''
});
const loading = ref(false);
const searched = ref(false);

const searchUser = async () => {
    if (emailError.value) {
        toast.add({ severity: 'info', summary: 'Email', detail: 'Please enter a valid email address.', life: 3000 });
        return;
    }

    loading.value = true;
    const accessToken = await auth0.getAccessTokenSilently();
    const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + 'sa/email', {
        method: 'POST',
        body: JSON.stringify({ email: emailSearch.value }),
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
    });
    const data = await response.json();
    const user = data.message;

    userData.value = {
        blocked: user.blocked ?? false,
        email: user.email ?? '',
        name: user.name ?? '',
        user_metadata: {
            role: user.user_metadata?.role ?? '',
            storeid: user.user_metadata?.storeid ?? ''
        },
        last_login: user.last_login ?? '',
        created_at: user.created_at ?? '',
        storename: user.storename ?? ''
    };
    loading.value = false;
    searched.value = true;
}

const emailError = computed(() => {
  if (!emailSearch.value) return false;
  return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailSearch.value);
});

const formatRelativeTime = (dateValue) => {
  return moment(dateValue).fromNow();
}

const formatRegularDate = (dateValue) => {
    return moment(dateValue).format('LL'); 
}

const copyToClipBoard = (storeid) => {
    navigator.clipboard.writeText(storeid);
}


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InputText, {
          modelValue: emailSearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailSearch).value = $event)),
          type: "email",
          placeholder: "Valid email addresses only",
          style: {"width":"16.5rem"}
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Button, {
          class: "p-button p-component btn-secondary p-button-rounded sml",
          type: "button",
          onClick: searchUser,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Search")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", {
      class: "container",
      hidden: !searched.value
    }, [
      _createElementVNode("div", _hoisted_4, [
        (userData.value.email !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(userData.value.name), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(userData.value.email), 1)
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(userData.value.user_metadata.role), 1)
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(userData.value.blocked ? 'Yes' : 'No'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", {
                    class: "tooltip",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipBoard(userData.value.user_metadata.storeid)))
                  }, [
                    _createTextVNode(_toDisplayString(userData.value.storename) + " ", 1),
                    _createElementVNode("span", _hoisted_18, [
                      _createTextVNode(_toDisplayString(userData.value.user_metadata.storeid) + " ", 1),
                      _hoisted_19
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(formatRegularDate(userData.value.created_at)), 1)
                ]),
                _createElementVNode("p", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(formatRelativeTime(userData.value.last_login)), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, " User not found. "))
      ])
    ], 8, _hoisted_3)
  ], 64))
}
}

})